import type { FC } from 'react';
import type { LineProps } from './index';

export const CircleLine: FC<LineProps> = ({ color, width, height }) => {
    return (
        <svg width={width} height="8" viewBox="0 0 90 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3 4L13 4" stroke={color} strokeWidth={height} />
            <path d="M15 4L25 4" stroke={color} strokeWidth={height} />
            <path d="M27 4L37 4" stroke={color} strokeWidth={height} />
            <path d="M39 4L49 4" stroke={color} strokeWidth={height} />
            <path d="M51 4L61 4" stroke={color} strokeWidth={height} />
            <path d="M63 4L73 4" stroke={color} strokeWidth={height} />
            <path d="M75 4L85 4" stroke={color} strokeWidth={height} />
            <circle cx="2" cy="4" r="1.5" stroke={color} strokeWidth={height} />
            <circle cx="14" cy="4" r="1.5" stroke={color} strokeWidth={height} />
            <circle cx="26" cy="4" r="1.5" stroke={color} strokeWidth={height} />
            <circle cx="38" cy="4" r="1.5" stroke={color} strokeWidth={height} />
            <circle cx="50" cy="4" r="1.5" stroke={color} strokeWidth={height} />
            <circle cx="62" cy="4" r="1.5" stroke={color} strokeWidth={height} />
            <circle cx="74" cy="4" r="1.5" stroke={color} strokeWidth={height} />
            <circle cx="86" cy="4" r="1.5" stroke={color} strokeWidth={height} />
        </svg>
    );
};
